import { render, staticRenderFns } from "./TutorialVideo.vue?vue&type=template&id=032ca45e&scoped=true"
import script from "./TutorialVideo.vue?vue&type=script&lang=js"
export * from "./TutorialVideo.vue?vue&type=script&lang=js"
import style0 from "./TutorialVideo.vue?vue&type=style&index=0&id=032ca45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032ca45e",
  null
  
)

export default component.exports